import { render, staticRenderFns } from "./InvocationReport.vue?vue&type=template&id=ffa069ee"
import script from "./InvocationReport.vue?vue&type=script&lang=js"
export * from "./InvocationReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports